import { createFileRoute } from "@tanstack/react-router";

import { CpaChangeHistoryPanel } from "@/features/ocpp/cpa-change-history/cpa-change-history-panel";

export interface CpaChangeHistorySearch {
  productCode?: string;
  channelId?: string;
  startTime?: string;
  endTime?: string;
}

export const Route = createFileRoute("/_authenticated/ocpp/cpa-change-history")(
  {
    validateSearch: (
      search: Record<string, unknown>,
    ): CpaChangeHistorySearch => ({
      productCode:
        typeof search.productCode === "string" ? search.productCode : undefined,
      channelId:
        typeof search.channelId === "string" ? search.channelId : undefined,
      startTime:
        typeof search.startTime === "string" ? search.startTime : undefined,
      endTime: typeof search.endTime === "string" ? search.endTime : undefined,
    }),
    component: CpaChangeHistoryRoute,
  },
);

function CpaChangeHistoryRoute() {
  return <CpaChangeHistoryPanel />;
}
